import { render, staticRenderFns } from "./potensiInvestasi.vue?vue&type=template&id=302aad34&"
import script from "./potensiInvestasi.vue?vue&type=script&lang=js&"
export * from "./potensiInvestasi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports
import {QCard,QSeparator,QCardSection,QDialog,QCardActions,QBtn,ClosePopup} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QCard,QSeparator,QCardSection,QDialog,QCardActions,QBtn})
component.options.directives = Object.assign(Object.create(component.options.directives || null), component.options.directives || {}, {ClosePopup})
